import { render, staticRenderFns } from "./PlanPartnerAgreement.vue?vue&type=template&id=2a7ebf55&scoped=true"
import script from "./PlanPartnerAgreement.vue?vue&type=script&lang=js"
export * from "./PlanPartnerAgreement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a7ebf55",
  null
  
)

export default component.exports